import { selectRedesignMobileConnectionPrice } from "../../MobileTariff/store";
import { selectConvergentData, selectMobileAndConvergentTariffPrice } from "../../../store/selectors";
export var selectPrice = selectMobileAndConvergentTariffPrice;
export var selectRatePeriodDays = function selectRatePeriodDays(state) {
  var _selectRedesignMobile;
  return (_selectRedesignMobile = selectRedesignMobileConnectionPrice(state)) === null || _selectRedesignMobile === void 0 || (_selectRedesignMobile = _selectRedesignMobile.data) === null || _selectRedesignMobile === void 0 ? void 0 : _selectRedesignMobile.rcRatePeriodDays;
};
export var selectBillingDate = function selectBillingDate(state) {
  var _selectRedesignMobile2;
  return (_selectRedesignMobile2 = selectRedesignMobileConnectionPrice(state)) === null || _selectRedesignMobile2 === void 0 || (_selectRedesignMobile2 = _selectRedesignMobile2.data) === null || _selectRedesignMobile2 === void 0 ? void 0 : _selectRedesignMobile2.billingDate;
};
export var selectTitle = function selectTitle(state) {
  var _selectConvergentData;
  return (_selectConvergentData = selectConvergentData(state)) === null || _selectConvergentData === void 0 ? void 0 : _selectConvergentData.title;
};